module.exports = __webpack_public_path__ + "static/media/tray19.12520fb2.png";